import React from "react";
import { motion } from "framer-motion";
import "react-modal-video/css/modal-video.min.css";
import { Button, Modal } from "react-bootstrap";
import { FaPlayCircle } from "react-icons/fa"; // React Icons kullanılarak play ikonu eklendi
import { useNavigate } from "react-router-dom";

const UpperSection = ({ categoryDetails, isModalOpen, setModalOpen }) => {
  const navigate = useNavigate();

  if (!categoryDetails) {
    return <div>Loading...</div>;
  }

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { delay: 0.2, duration: 0.6 } },
  };

  const videoSrc = categoryDetails.video; // Video URL is stored here
  const thumbnail = categoryDetails.images[0] || "default_thumbnail.jpg"; // Default or specified image thumbnail

  return (
    <motion.div
      className="upper-section container-fluid my-md-2 shadow-lg rounded-2 px-3 py-5"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="row">
        <div className="d-flex justify-content-center align-items-center mb-2 mb-md-4">
          <h2 className="text-center">
            {categoryDetails.titel}
            <br />
            <span className="fs-4">{categoryDetails.titelAlt}</span>
          </h2>

          <Button
            variant="secondary position-absolute start-0 ms-1 ms-md-5 opacity-50"
            onClick={() => navigate(-1)}
          >
            Zurück
          </Button>
        </div>
        <div className="row mx-auto">
          <motion.div
            className="col-12 col-xl-6 video-content mb-3 position-relative mx-auto"
            variants={containerVariants}
          >
            <img
              src={thumbnail}
              alt="Video Thumbnail"
              className="w-100 h-100 border border-3 border-dark"
              onClick={() => setModalOpen(true)}
              style={{ cursor: "pointer", width: "100%", maxHeight: "400px" }}
            />
            {videoSrc && (
              <FaPlayCircle
                className="play-icon"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "white",
                  fontSize: "4rem",
                  pointerEvents: "none", // Bunu ekleyerek simgenin üzerine tıklama engellenir
                }}
              />
            )}
            <Modal
              show={isModalOpen}
              onHide={() => setModalOpen(false)}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  {videoSrc ? "Video Preview" : "Foto Preview"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {videoSrc ? (
                  <video
                    src={videoSrc}
                    controls
                    autoPlay
                    style={{ width: "100%" }}
                  ></video>
                ) : (
                  <img
                    src={thumbnail}
                    alt="Video Thumbnail"
                    onClick={() => setModalOpen(true)}
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      maxHeight: "400px",
                    }}
                    height={600}
                  />
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => setModalOpen(false)}>Schließen</Button>
              </Modal.Footer>
            </Modal>
          </motion.div>
          <div
            className="col-12 text-content d-flex flex-column justify-content-center mb-3 order-1 order-xl-0 px-md-3 px-lg-4 px-xl-5 responsive-fs"
            style={{
              textAlign: "justify",
              textIndent: "1.5em",
            }}
          >
            <p>{categoryDetails.desc || categoryDetails.desc2}</p>
            <p>{categoryDetails.desc2 || ""}</p>
            <p>{categoryDetails.desc3 || ""}</p>
            <p>{categoryDetails.desc4 || ""}</p>
            <p>{categoryDetails.desc5 || ""}</p>
            <p style={{ textIndent: "1em" }}>
              {categoryDetails.desc6 || ""}
              <div>{categoryDetails.desc61 || ""}</div>
              <div>{categoryDetails.desc62 || ""}</div>
              <div>{categoryDetails.desc63 || ""}</div>
              <div>{categoryDetails.desc64 || ""}</div>
              <div>{categoryDetails.desc65 || ""}</div>
            </p>
            <p
              dangerouslySetInnerHTML={{ __html: categoryDetails.desc7 || "" }}
            ></p>
            <p>{categoryDetails.desc8 || ""}</p>
            <p>{categoryDetails.desc9 || ""}</p>
            <p>{categoryDetails.desc10 || ""}</p>
            <p>{categoryDetails.desc11 || ""}</p>
            <p>{categoryDetails.desc12 || ""}</p>
            <p>{categoryDetails.desc13 || ""}</p>
            <p>{categoryDetails.desc14 || ""}</p>
            <div>
              <small className="text-secondary ms-2">
                Die Veranstaltung fand am{" "}
                <span className="text-dark">
                  {categoryDetails.date || categoryDetails.time || "..."}
                </span>{" "}
                statt.
              </small>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default UpperSection;
